import type { SalesChecklistSection } from "@expert/contentful";

import { colorOverrides } from "@expert/theme/overrides/colors";
import { Accordion, Flex, Group, ScrollArea, Text } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";

import { LanguageSelector } from "@/sales-tools/language-selector/LanguageSelector";

import { ChecklistIcon } from "../../Icons";

export function ChecklistSectionFallback({ section }: { section: SalesChecklistSection }) {
    return (
        <Accordion.Item value={section.title} bg={"#C92A2A1A"}>
            <Accordion.Control>
                <Text size="xs" c="dark.1" fw="var(--mantine-font-weight-heavy)">
                    {section.title}
                </Text>
            </Accordion.Control>
            <Accordion.Panel styles={{ content: { paddingTop: 0, paddingBottom: 8 } }}>
                <Text fz={10} c="error.3">
                    Oops! We had issues loading this.
                </Text>
            </Accordion.Panel>
        </Accordion.Item>
    );
}

export function FullChecklistErrorFallback() {
    return (
        <Flex data-testid="step-two-content" direction="column" w="100%">
            <ScrollArea h="calc(100% - var(--customer-panel-bottom-control-footer-height))">
                <Flex px="sm" py={8} bg="#C92A2A1A" w={"100%"} h={30}>
                    <Group gap={8}>
                        <IconAlertTriangle size={16} color={colorOverrides.error?.[3]} />
                        <Text size="xs" c="error.3" fw={500}>
                            Oops! We had issues loading this.
                        </Text>
                    </Group>
                </Flex>
                <Flex id="full-offer-checklist-header" c="dark.2" px="xl" py="md" pb="xxs" justify="space-between">
                    <Flex align="center">
                        <ChecklistIcon />
                        <Text fw={700} fz="xs" pl="3xs">
                            OFFER CHECKLIST
                        </Text>
                    </Flex>
                    <LanguageSelector />
                </Flex>
            </ScrollArea>
        </Flex>
    );
}
